import React, { useEffect, useState } from "react";
import { getSessionStats } from "../services/monitorService";
import { todayStats } from "../services/auditLogService";
import { useFirestoreAdmin } from "../context/FirestoreAdminProvider";

export default function MonitorPage() {
  const { user } = useFirestoreAdmin();
  const [session, setSession] = useState(getSessionStats());
  const [today, setToday] = useState({ updates: 0, deletes: 0 });

  useEffect(() => {
    const id = setInterval(() => setSession(getSessionStats()), 2000);
    todayStats(user?.uid).then(setToday);
    return () => clearInterval(id);
  }, [user?.uid]);

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-bold">Firestore Monitor</h1>
        <p className="text-sm text-slate-600">Session activity and today&apos;s audit totals.</p>
      </header>
      <div className="fa-kpi-grid">
        <div className="fa-kpi"><p className="fa-kpi-label">Session reads</p><p className="fa-kpi-value">{session.reads}</p></div>
        <div className="fa-kpi"><p className="fa-kpi-label">Session writes</p><p className="fa-kpi-value">{session.writes}</p></div>
        <div className="fa-kpi"><p className="fa-kpi-label">Session deletes</p><p className="fa-kpi-value">{session.deletes}</p></div>
        <div className="fa-kpi"><p className="fa-kpi-label">Today updates</p><p className="fa-kpi-value">{today.updates}</p></div>
        <div className="fa-kpi"><p className="fa-kpi-label">Today deletes</p><p className="fa-kpi-value">{today.deletes}</p></div>
      </div>
      <div className="fa-card p-4">
        <h3 className="mb-2 font-semibold">Timeline</h3>
        <ul className="max-h-64 space-y-1 overflow-auto text-xs font-mono">
          {session.timeline.slice().reverse().map((e, i) => (
            <li key={i}>{e.at} — {e.type} ×{e.count}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
